import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, filter, map, of } from 'rxjs';
import { BasedComponent } from '@shared/components/based.component';
import { Utilities } from '@app/shared/utils/utilities';

@Component({
  selector: 'app-message-data',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './message-data.component.html',
  styleUrl: './message-data.component.css'
})
export class MessageDataComponent extends BasedComponent {
  @Input() errorMsg$: Observable<string[]> = of([]); // | string[];
  @Input() infoMsg$: Observable<string[]> = of([]); // | string[];

  clearedErrorMsg$: Observable<string[]>;
  clearedInfoMsg$: Observable<string[]>;

  // errorMsg: string[] = [];
  // infoMsg: string[] = [];

  override ngOnInit() {
    super.ngOnInit();
    this.clearedErrorMsg$ = this.errorMsg$.pipe(filter(v => v !== null && v !== undefined), map(msg => msg.filter(item => !Utilities.isEmptyString(item))));
    this.clearedInfoMsg$ = this.infoMsg$.pipe(filter(v => v !== null && v !== undefined), map(msg => msg.filter(item => !Utilities.isEmptyString(item))));

    //   if (isObservable(this.errorMsg$)) {
    //     this.errorMsg$.pipe(takeUntil(this.destroy$)).subscribe(c => this.errorMsg = c);
    //   }
    //   else {
    //     this.errorMsg = this.errorMsg$;
    //   }

    //   if (isObservable(this.infoMsg$)) {
    //     this.infoMsg$.pipe(takeUntil(this.destroy$)).subscribe(c => this.infoMsg = c);
    //   }
    //   else {
    //     this.infoMsg = this.infoMsg$;
    //   }
  }
}
